import { ContainerModule } from '@patsnap/tahiti-core/shared/inversify';
import { GetIsFreeViewService } from '@/services/common/get-is-free-view.interface';
import { getIsFreeView } from 'library-@/utils/patent-view-free-judgment-util';
import { GetFullParamsService } from '@/services/common/get-full-params.interface';
import { constructFullParamsCallback } from '@/lib/api/index.js';
import psHttp, { psHttp$ } from '@patsnap/common-ps-http';
import { PsHttp } from '@patsnap/tahiti-core/common/ps-http';
import { HttpErrorHandlerContribution, HttpErrorHandlerRegistry, HttpErrorHandlerRegistryImpl } from '@patsnap/tahiti-core/common/http-error-handler-contribution';
import { bindContributionProvider } from '@patsnap/tahiti-core/common/contribution-provider';
import { PsHttp$, PsHttpChannel, PsHttpChannelImpl } from '@patsnap/tahiti-core/common/http-channel';
import { Message } from '@patsnap/tahiti-core/common/message';
import { Toast } from 'patsnap-biz';
import { CookieService } from '@analytics/shared/services/cookie-service';
import { LocationService, LocationServiceImpl } from '@analytics/shared/services/location-service';
import { OpenService, OpenServiceImpl } from '@analytics/shared/services/open-service';
import { LanguageService, LanguageServiceImpl } from '@analytics/shared/services/language-service';
import { I18nService } from '@analytics/shared/services/i18n.interface';
import { getI18nInstance } from '@/locales/i18nInstance';
import router from '@/router';
import { VueRouterService } from '@analytics/shared/services/vue-router-service.interface';
import { IndexDBService } from '@/domains/claim-charting/services/index-data-base-service';
import { IndexDBServiceImpl } from '@/domains/claim-charting/services/impls/index-data-base-service';
import { SSEPsHttpImpl, PsHttpSSE, FactoryPsHttpSSE } from '@patsnap-utils/sse';

export const baseModule = new ContainerModule((bind) => {
    bind(HttpErrorHandlerRegistry).to(HttpErrorHandlerRegistryImpl);
    bindContributionProvider(bind, HttpErrorHandlerContribution);
    bind(PsHttp).toConstantValue(psHttp);
    bind(PsHttp$).toConstantValue(psHttp$);
    bind(PsHttpChannel).to(PsHttpChannelImpl);
    bind(Message).toConstantValue(Toast);
    bind(LocationService).to(LocationServiceImpl);
    bind(CookieService).toConstantValue(document.cookie);
    bind(LanguageService).to(LanguageServiceImpl);
    bind(I18nService).toDynamicValue(() => getI18nInstance());
    bind(VueRouterService).toConstantValue(router);
    bind(OpenService).to(OpenServiceImpl);
    bind(IndexDBService).to(IndexDBServiceImpl);
    bind(GetIsFreeViewService).toConstantValue({
        getIsFreeView: getIsFreeView,
    });
    bind(GetFullParamsService).toConstantValue({
        getFullParams: constructFullParamsCallback,
    });
    bind(PsHttpSSE).to(SSEPsHttpImpl).inRequestScope();
    bind(FactoryPsHttpSSE).toDynamicValue(context => () => context.container.get(PsHttpSSE));
});
